// import Circuit from "./detail/curves/circuit"
import RenderCofabComponent from "./renderCofabComponent"
import Figure from "./detail/curves/figure"
import groups3a from "./groups3a"
import Model from "./interfaces/model"
import Logo from "./logo"

export default class Master extends Component {
  state = { activeNeuron: 388, InceptionV1: null }

  fetchGraphs = async () => {
    const { InceptionV1 } = await (await fetch("/graphs.json")).json()
    this.setState({ InceptionV1 })
  }

  componentWillMount() {
    this.fetchGraphs()
  }

  render() {
    const { InceptionV1 } = this.state

    const Header = ({ children }) => (
      <Text
        marginLeft={140}
        fontSize={34}
        marginY={20}
        opacity={0.9}
        fontWeight={400}
        fontFamily="font-family: 'Ropa Sans', sans-serif;"
      >
        {children}
      </Text>
    )

    const moduleBg = `rgba(255, 255, 255,0.8)`

    const highlightColor = `rgba(228, 118, 88, 0.9)`
    const ModuleTitle = ({ children, subtitle, headerSize, fontSize = 24 }) => (
      <Surface flexFlow="row">
        <Text
          fontSize={headerSize || fontSize}
          opacity={0.7}
          lineHeight={1.15}
          fontWeight={600}
          marginLeft={10}
        >
          {children}
        </Text>
        {subtitle && (
          <Text
            marginLeft={5}
            fontSize={fontSize}
            opacity={0.4}
            lineHeight={1.15}
            fontWeight={600}
            marginLeft={10}
          >
            {subtitle}
          </Text>
        )}
      </Surface>
    )

    const ZoomedImg = ({
      src,
      size,
      padding,
      style,
      xOffset = 0,
      ...props
    }) => (
      <div
        style={Object.assign({}, style, {
          width: size,
          height: size,
          overflow: "hidden",
          borderRadius: 5,
          position: "relative",
        })}
        {...props}
      >
        <img
          src={src}
          width={size + padding * 2}
          height={size + padding * 2}
          style={{
            position: "absolute",
            left: -padding - xOffset,
            top: -padding,
          }}
        />
      </div>
    )

    const gridGap = 5
    const NeuronSet = ({
      title,
      headerSize,
      layer = "mixed3b",
      cols,
      rows,
      subtitle,
      neurons,
      padding = 20,
      neuronSize = 55,
      marginX = 15,
    }) => (
      <Surface marginX={marginX} marginY={20} minWidth={250}>
        <ModuleTitle headerSize={headerSize} subtitle={subtitle}>
          {title}
        </ModuleTitle>
        <Surface
          display="grid"
          alignSelf="center"
          gridTemplateColumns={`repeat(${cols}, ${neuronSize}px)`}
          gridTemplateRows={`repeat(${rows}, ${neuronSize}px)`}
          gridGap={gridGap}
          padding={5}
          borderRadius={5}
          marginTop={10}
          background={moduleBg}
          width={neuronSize * cols + gridGap * cols + 10}
          height={neuronSize * rows + gridGap * rows + 10}
          style={{ border: `2px solid rgba(0, 0, 0, 0.2)` }}
          boxShadow="0 30px 60px -12px rgba(50,50,93,.04), 0 18px 36px -18px rgba(0,0,0,.06), 0 -12px 36px -8px rgba(0,0,0,.025)"
        >
          {neurons.map((neuron, index) => (
            <ZoomedImg
              padding={padding}
              xOffset={5}
              size={neuronSize}
              src={`https://storage.googleapis.com/fls/nickc/neuron_renders/${layer}_${neuron}.jpg`}
            />
          ))}
        </Surface>
      </Surface>
    )

    return (
      <Surface width="100%">
        <Logo />
        <Surface marginBottom={40}>
          <Header>
            The neurons of neural networks learn human-meaningful
            representations
          </Header>
          <Figure>
            <Surface flexFlow="row" alignSelf="center">
              <NeuronSet
                title="Curves"
                subtitle="3b"
                rows={2}
                neuronSize={120}
                cols={4}
                padding={10}
                neurons={[359, 379, 385, 343, 330, 340, 388, 342]}
              />
              <NeuronSet
                title="Dog Faces"
                subtitle="4d"
                rows={2}
                neuronSize={120}
                layer="mixed4d"
                padding={10}
                cols={3}
                neurons={[482, 43, 477, 28, 64, 78]}
              />
              <NeuronSet
                title="People"
                layer="mixed4d"
                subtitle="4d"
                rows={1}
                cols={3}
                neuronSize={120}
                padding={10}
                neurons={[483, 474, 336]}
              />
            </Surface>
          </Figure>
        </Surface>
        <Surface marginBottom={40}>
          <Header>
            It's tractable to understand every neuron in a neural network
          </Header>
          <Figure>
            <Surface
              flexFlow="row"
              alignSelf="center"
              flexWrap="wrap"
              alignItems="center"
              justifyContent="center"
              width="100%"
              paddingX={10}
            >
              <Surface width={450} marginY={20} marginX={40}>
                <Text size={600} fontSize={20} lineHeight={1.3}>
                  Most neurons in a neural network fit into simple conceptual
                  groups.
                </Text>
                <Text size={600} fontSize={20} lineHeight={1.3} marginTop={20}>
                  These groups are 70% of the neurons in 3a, an early
                  convolutional layer in InceptionV1.
                </Text>

                <Text size={600} fontSize={20} lineHeight={1.3} marginTop={20}>
                  They make up 20% of the model's "early vision" neurons, and 2%
                  of all neurons.
                </Text>
              </Surface>
              <NeuronSet
                title="Texture"
                subtitle="~16%"
                layer="mixed3a"
                rows={5}
                cols={6}
                neurons={groups3a["mixed3a_pure_texture"]}
              />
              <NeuronSet
                title="Dot"
                subtitle="~12%"
                layer="mixed3a"
                rows={5}
                cols={6}
                neurons={groups3a["mixed3a_center_surround"]}
              />
              <NeuronSet
                title="Brightness Gradient"
                subtitle="~6%"
                layer="mixed3a"
                rows={5}
                cols={3}
                neurons={groups3a["mixed3a_gradient"]}
              />
              <NeuronSet
                title="High-low Frequency"
                subtitle="~6%"
                layer="mixed3a"
                // neurons={groups3a["mixed3a_highlow"]}
                rows={3}
                cols={4}
                neurons={groups3a["mixed3a_highlow"].slice(0, 12)}
              />
              <NeuronSet
                title="Color-Constrast"
                subtitle="~9%"
                layer="mixed3a"
                rows={3}
                cols={4}
                neurons={groups3a["mixed3a_color_contrast"].slice(0, 12)}
              />
              <NeuronSet
                title="Repeated Edge"
                subtitle="~6%"
                layer="mixed3a"
                rows={2}
                cols={3}
                neurons={groups3a["mixed3a_line_grad"].slice(0, 6)}
              />
              <NeuronSet
                title="Early Curves"
                subtitle="~4%"
                layer="mixed3a"
                rows={3}
                cols={3}
                neurons={groups3a["mixed3a_curve"].slice(0, 9)}
              />
              <NeuronSet
                title="Repeated Pattern"
                subtitle="~4%"
                layer="mixed3a"
                rows={3}
                cols={3}
                neurons={groups3a["mixed3a_pattern"].slice(0, 9)}
              />
              <NeuronSet
                title="Edge"
                subtitle="~3%"
                layer="mixed3a"
                rows={1}
                cols={3}
                neurons={groups3a["mixed3a_edges_pattern"].slice(0, 3)}
              />
              <NeuronSet
                title="Triangles"
                subtitle="~1%"
                layer="mixed3a"
                rows={1}
                cols={3}
                neurons={groups3a["mixed3a_tri_and_angle"].slice(0, 3)}
              />
            </Surface>
            {false && InceptionV1 && (
              <Surface marginTop={30} marginBottom={30}>
                <Surface
                  flexFlow="row"
                  alignSelf="center"
                  justifyContent="space-between"
                  marginY={10}
                >
                  <Text
                    fontSize={23}
                    marginX={20}
                    fontWeight={600}
                    opacity={0.8}
                  >
                    70% of layer 3a
                  </Text>
                  <Text
                    fontSize={23}
                    marginX={20}
                    fontWeight={600}
                    opacity={0.8}
                  >
                    20% of "Early Vision"
                  </Text>
                  <Text
                    fontSize={23}
                    marginX={20}
                    fontWeight={600}
                    opacity={0.8}
                  >
                    2% of full model
                  </Text>
                </Surface>
                <Surface
                  alignSelf="center"
                  marginTop={40}
                  overflow="visible"
                  transform="scale(1.4)"
                >
                  <Model
                    data={InceptionV1}
                    isNodeActive={node => {
                      return node.id === "mixed3a"
                    }}
                  />
                </Surface>
              </Surface>
            )}
          </Figure>
        </Surface>
        <Surface marginBottom={40}>
          <Header>
            Their connections form interpretable circuits that show up across
            models
          </Header>
          <Figure>
            <Surface alignSelf="center">
              <RenderCofabComponent
                folder="curves-circuit-inceptionv3"
                additionalProps={{ showFigure: false, showHeader: false }}
                component={Circuit}
              />
              <Surface
                flexFlow="row"
                justifyContent="space-between"
                alignSelf="center"
                marginTop={50}
                width={1300}
              >
                <Surface>
                  <Text size={600} marginY={5} alignSelf="center">
                    AlexNet has a simple curve circuit that primarily forms in
                    one layer
                  </Text>
                  <Surface
                    width={600}
                    height={300}
                    background="rgba(0, 0, 0, 0.05)"
                    style={{ border: "1px solid rgba(0, 0, 0, 0.2)" }}
                    borderRadius={5}
                  >
                    <Surface
                      transform="scale(0.4) translate(450px, 20px)"
                      transformOrigin="top left"
                    >
                      <RenderCofabComponent
                        folder="curves-circuit-alexnet"
                        additionalProps={{
                          showFigure: false,
                          showLines: false,
                          showHeader: false,
                        }}
                        component={Circuit}
                      />
                    </Surface>
                  </Surface>
                </Surface>
                <Surface>
                  <Text size={600} marginY={5} alignSelf="center">
                    InceptionV1 has a layer of 2d curves followed by 3d curves
                  </Text>
                  <Surface
                    width={600}
                    height={300}
                    background="rgba(0, 0, 0, 0.05)"
                    style={{ border: "1px solid rgba(0, 0, 0, 0.2)" }}
                    borderRadius={5}
                  >
                    <Surface
                      transform="scale(0.4)"
                      transform="scale(0.4) translate(450px, 70px)"
                      transformOrigin="top left"
                    >
                      <RenderCofabComponent
                        folder="curves-circuit"
                        additionalProps={{
                          showFigure: false,
                          showLines: false,
                          showHeader: false,
                        }}
                        component={Circuit}
                      />
                    </Surface>
                  </Surface>
                </Surface>
              </Surface>
            </Surface>
          </Figure>
        </Surface>
      </Surface>
    )
  }
}
